/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free online readability checker. Paste your text to get the Flesch Reading Ease score, Flesch-Kincaid grade level, and word, sentence, and syllable counts. Works in your browser.`)
};

const es_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprobador de legibilidad en línea gratuito. Pega tu texto para obtener la puntuación Flesch Reading Ease, el nivel de grado Flesch–Kincaid, y conteos de palabras, oraciones y sílabas. Funciona en tu navegador.`)
};

const de_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenloser Lesbarkeitstest online. Fügen Sie Ihren Text ein, um den Flesch Reading Ease-Wert, die Flesch-Kincaid-Klassenstufe sowie die Anzahl der Wörter, Sätze und Silben zu erhalten. Funktioniert direkt im Browser.`)
};

const nl_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gratis online leesbaarheidscontrole. Plak uw tekst om de Flesch Reading Ease-score, Flesch-Kincaid-graadniveau en woord-, zin- en lettergreeptellingen te verkrijgen. Werkt in uw browser.`)
};

const fr_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vérificateur de lisibilité en ligne gratuit. Collez votre texte pour obtenir le score Flesch Reading Ease, le niveau Flesch–Kincaid et le nombre de mots, phrases et syllabes. Fonctionne dans votre navigateur.`)
};

const it_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificatore gratuito di leggibilità online. Incolla il tuo testo per ottenere il punteggio Flesch Reading Ease, il livello scolastico Flesch-Kincaid e i conteggi di parole, frasi e sillabe. Funziona nel tuo browser.`)
};

const pt_br2_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificador de legibilidade online gratuito. Cole seu texto para obter a pontuação Flesch Reading Ease, nível de série Flesch-Kincaid e contagem de palavras, sentenças e sílabas. Funciona no seu navegador.`)
};

const pt_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verificador de legibilidade gratuito online. Cole o seu texto para obter a pontuação Flesch Reading Ease, o nível de escolaridade Flesch–Kincaid, e a contagem de palavras, frases e sílabas. Funciona no seu navegador.`)
};

const ja_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料のオンライン読みやすさチェッカー。テキストを貼り付けると、Flesch Reading Easeスコア、Flesch–Kincaidグレードレベル、単語数、文数、音節数が表示されます。ブラウザで動作します。`)
};

const zh_ra_meta_description = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费在线可读性检测工具。粘贴文本即可获取 Flesch Reading Ease 分数、Flesch-Kincaid 年级水平，以及字数、句数和音节数统计。在浏览器中运行。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ra_meta_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ra_meta_description(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ra_meta_description", locale)
	if (locale === "en") return en_ra_meta_description(inputs)
	if (locale === "es") return es_ra_meta_description(inputs)
	if (locale === "de") return de_ra_meta_description(inputs)
	if (locale === "nl") return nl_ra_meta_description(inputs)
	if (locale === "fr") return fr_ra_meta_description(inputs)
	if (locale === "it") return it_ra_meta_description(inputs)
	if (locale === "pt-BR") return pt_br2_ra_meta_description(inputs)
	if (locale === "pt") return pt_ra_meta_description(inputs)
	if (locale === "ja") return ja_ra_meta_description(inputs)
	return zh_ra_meta_description(inputs)
};